import styled from 'styled-components';
export const DetailWrapper = styled.div.withConfig({
  displayName: "Detailstyle__DetailWrapper",
  componentId: "sc-ui2uzi-0"
})(["", " max-width:750px;@media (max-width:", "){", "}"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "marginTop": "3rem",
  "marginBottom": "3rem",
  "width": "100%"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "1.5rem",
  "marginBottom": "1.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem"
});
export const Title = styled.h1.withConfig({
  displayName: "Detailstyle__Title",
  componentId: "sc-ui2uzi-1"
})(["", " @media (max-width:", "){", "}"], {
  "marginBottom": "1rem",
  "marginTop": "1.5rem",
  "fontSize": "3rem",
  "lineHeight": "1",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(23 23 23 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginBottom": "0.5rem",
  "marginTop": "1rem",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem"
});
export const Desceiption = styled.p.withConfig({
  displayName: "Detailstyle__Desceiption",
  componentId: "sc-ui2uzi-2"
})(["", " @media (max-width:", "){", "}"], {
  "marginBottom": "1.5rem",
  "fontSize": "28px",
  "fontWeight": "400",
  "lineHeight": "30px",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginBottom": "1rem",
  "fontSize": "1.5rem",
  "lineHeight": "2rem"
});
export const Wrapper = styled.div.withConfig({
  displayName: "Detailstyle__Wrapper",
  componentId: "sc-ui2uzi-3"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between"
});
export const ButtonWrapper = styled.div.withConfig({
  displayName: "Detailstyle__ButtonWrapper",
  componentId: "sc-ui2uzi-4"
})(["", " @media (max-width:", "){", "}"], {
  "display": "flex",
  "gap": "0.5rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gap": "0.75rem"
});